import { Routes } from "@angular/router";
import { LoginComponent } from "../pages/login/login.component";
import { LogoutComponent } from "../pages/logout/logout.component";
import { RegisterComponent } from "../pages/register/register.component";
import { RegistrationLandingComponent } from "../pages/registration-landing/registration-landing.component";
import { ForgotPasswordComponent } from "../pages/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "../pages/reset-password/reset-password.component";


export const authModuleBaseRoute = 'authentication';

export const authModuleRoutes = {
  register: 'register',
  registrationLanding: 'registration-landing',
  profile: 'profile/:userName',
  login: 'login',
  loginFailed: 'login-failed',
  loginCallback: 'login-callback',
  logout: 'logout',
  loggedOut: 'logged-out',
  logoutCallback: 'logout-callback',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  defaultLoginRedirectPath: '/',
};

export const AUTH_ROUTES: Routes = [
  { path: authModuleRoutes.register, component: RegisterComponent },
  { path: authModuleRoutes.registrationLanding, component: RegistrationLandingComponent },
  { path: authModuleRoutes.login, component: LoginComponent },
  { path: authModuleRoutes.loginFailed, component: LoginComponent },
  { path: authModuleRoutes.loginCallback, component: LoginComponent },
  { path: authModuleRoutes.logout, component: LogoutComponent },
  { path: authModuleRoutes.loggedOut, component: LogoutComponent },
  { path: authModuleRoutes.logoutCallback, component: LogoutComponent },
  { path: authModuleRoutes.forgotPassword, component: ForgotPasswordComponent },
  { path: authModuleRoutes.resetPassword, component: ResetPasswordComponent }
];

export const authModulePathComponents = {
  register: [authModuleBaseRoute].concat(authModuleRoutes.register.split('/')),
  registrationConfirmation: [authModuleBaseRoute].concat(authModuleRoutes.registrationLanding.split('/')),
  profile: [authModuleBaseRoute].concat(authModuleRoutes.profile.split('/')),
  login: [authModuleBaseRoute].concat(authModuleRoutes.login.split('/')),
  loginFailed: [authModuleBaseRoute].concat(authModuleRoutes.loginFailed.split('/')),
  loginCallback: [authModuleBaseRoute].concat(authModuleRoutes.loginCallback.split('/')),
  logout: [authModuleBaseRoute].concat(authModuleRoutes.logout.split('/')),
  loggedOut: [authModuleBaseRoute].concat(authModuleRoutes.loggedOut.split('/')),
  logoutCallback: [authModuleBaseRoute].concat(authModuleRoutes.logoutCallback.split('/')),
  forgotPassword: [authModuleBaseRoute].concat(authModuleRoutes.forgotPassword.split('/')),
  resetPassword: [authModuleBaseRoute].concat(authModuleRoutes.resetPassword.split('/')),
};
